import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { getBusinessImprovementPlanGeneralData, getListOfBusinessPlans } from "../_redux/BusinessImprovementPlanActions";
import { BigBoldText, BoldText, LightText, NormalText, PrimaryBoldText, PrimaryNormalText, SmallBoldText, SmallNormalText } from "../../../../utils/typographyUtils";
import "../business-improvement-plan.scss";
import LoadingAnimation from "../../../../base/LoadingAnimation";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import { BUSINESS_IMPROVEMENT_PLAN_VIEW, COURSE_OVERVIEW } from "../../../../data/RouteUrls";
import StandardButton from "../../../shared/formComponents/StandardButton/StandardButton";
import ButtonIcon from "../../../shared/formComponents/StandardButton/ButtonIcon";
import { ChevronRight } from "lucide-react";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import HabitBuilderTable from "../../../shared/HabitBuilderTable/HabitBuilderTable";
import BusinessImprovementPlanHeader from "../BusinessImprovementPlanHeader/BusinessImprovementPlanHeader";
export default function BusinessImprovementPlanHome() {
  const dispatch = useDispatch();
  const params = useParams();
  const history = useHistory();
  const [businessPlanGeneralData, setBusinessPlanGeneralData] = useState(null);
  const [businessPlans, setBusinessPlans] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const tableHeaders = [
    // {
    //   title: "#",
    //   dataField: "index",
    // },
    {
      title: "Scalability Plan",
      dataField: "quarter",
    },
    {
      title: "Starting BMIx",
      dataField: "startingBmiScore",
    },
    {
      title: "Ending BMIx",
      formatter: (row, index) => {
        return (
          <NormalText>
            {row.endingBmiScore ? row.endingBmiScore : "-"}
          </NormalText>
        );
      },
    },
    {
      title: "Status",
      // dataField: "latest_bip_state",
      formatter: (row, index) => getStatusText(row),
    },
    {
      title: "Action",
      formatter: (row, index) => {
        return (
          <div className="d-flex align-items-center gap-1">
            <img src="/assets/images/icon-eye.svg" alt="view" />
            <PrimaryNormalText
              onClick={() => {
                history.push(
                  BUSINESS_IMPROVEMENT_PLAN_VIEW.replace(
                    ":planId",
                    row.businessPlanId,
                  ).replace(":userId", params.userId),
                );
              }}
              classNames={"text-decoration-underline cursor-pointer mt-1"}
            >
              View
            </PrimaryNormalText>
          </div>
        );
      },
    },
  ];

  const getStatusText = (plan) => {
    let txt = "";

    if (plan.isArchived) {
      txt = "Archived";
    } else if (plan.isClosed) {
      txt = "Closed Out";
    }
    if (txt) {
      return <NormalText>{txt}</NormalText>;
    }
    return <NormalText>In Progress</NormalText>;
  };

  const getInitialData = async () => {
    try {
      let data = await dispatch(getBusinessImprovementPlanGeneralData(params.userId));
      let listOfBusinessPlans = await dispatch(getListOfBusinessPlans(params.userId));
      setBusinessPlanGeneralData(data.data);
      setBusinessPlans(listOfBusinessPlans.data);
      setIsLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  const renderBIPSteps = () => {
    const steps = [
      {
        title: "Generate Scaling Plan:",
        description:
          "Use AI to generate a draft plan with OKRs based on X-Ray recommendations.",
        icon: "/assets/images/lock-light-icon.svg",
      },
      {
        title: "Customise the plan:",
        description:
          "Adjust the AI-generated Scalability OKRs to fit your business context and priorities.",
        icon: "/assets/images/lock-light-icon.svg",
      },
      {
        title: "Share the plan:",
        description:
          "Give your team direction and align their effort towards achieving your Scalability OKRs.",
        icon: "/assets/images/lock-light-icon.svg",
      },
    ];

    // ALL LOCKED IF XRAY NOT COMPLETED
    if (
      !businessPlanGeneralData?.isXRayCompleted ||
      (businessPlanGeneralData?.isCoachAssigned &&
        !businessPlanGeneralData?.isXRayReviewCompleted)
    ) {
      return (
        <div className="d-flex flex-column gap-2 mt-1">
          {steps.map((step, index) => (
            <div key={index} className="d-flex align-items-center gap-2">
              <img src={step.icon} alt="lock" width={20} height={20} />
              <div>
                <BoldText>{step.title}</BoldText>
                <NormalText classNames={"ms-1"}>{step.description}</NormalText>
              </div>
            </div>
          ))}
        </div>
      );
    }

    // When xray is completed and user is BIP Leader
    if (businessPlanGeneralData?.isXRayCompleted) {
      const stepsState = steps.map((step, index) => {
        if (index === 0 && businessPlanGeneralData?.showGenerateButton) {
          return {
            ...step,
            icon: "/assets/images/bip-in-progress.svg",
            status: "in-progress",
          };
        }

        if (
          !businessPlanGeneralData?.showGenerateButton &&
          !businessPlanGeneralData?.isPublished
        ) {
          if (index === 0) {
            return {
              ...step,
              icon: "/assets/images/check-purple.svg",
              status: "completed",
            };
          }
          if (index === 1) {
            return {
              ...step,
              icon: "/assets/images/bip-in-progress.svg",
              status: "in-progress",
            };
          }
        }

        if (businessPlanGeneralData?.isPublished) {
          if (index <= 1) {
            return {
              ...step,
              icon: "/assets/images/check-purple.svg",
              status: "completed",
            };
          }
          if (index === 2) {
            return {
              ...step,
              icon: "/assets/images/check-purple.svg",
              status: "completed",
            };
          }
        }

        return step;
      });

      return (
        <div className="d-flex flex-column gap-2 mt-1">
          {stepsState.map((step, index) => (
            <div key={index} className="d-flex align-items-center gap-2">
              <img src={step.icon} alt={step.status} width={20} height={20} />
              <div>
                <BoldText>{step.title}</BoldText>
                <NormalText classNames={"ms-1"}>{step.description}</NormalText>
              </div>
            </div>
          ))}
        </div>
      );
    }

    return null;
  };

  const renderInfoText = () => {
    let text = "";
    if (!businessPlanGeneralData.isXRayCompleted) {
      text = "Scalability Plan can be created by the leader only after X-Ray is completed and reviewed by you.";
    } else if (businessPlanGeneralData.isXRayCompleted && !businessPlanGeneralData.isXRayReviewCompleted) {
      text = "Scalability Plan unlocks once you review the X-Ray. Please complete your review."
    } else if (businessPlanGeneralData.latest_bip_state === "Empty" || businessPlanGeneralData.latest_bip_state === "") {
      text = "Waiting on the leader to start the plan. You’ll be able to view it once they do.";
    } 
    // else if (businessPlanGeneralData.latest_bip_state === "Draft") {
    //   text = "The leader is finalising the Business Improvement Plan. Entire team be notified once they publish it.";
    // }

    if (text) {
      return <div className="d-flex align-items-center bg-light-new w-fit-content mb-4 mt-3 px-3 py-2">
        <img
          src="/assets/images/warning-red.svg"
          height={15}
          width={15}
          className="me-1"
        />
        <LightText>{text}</LightText>

      </div>
    } else {
      return null;
    }
  }


  useEffect(() => {
    getInitialData();
  }, []);

  if (isLoading) {
    return <LoadingAnimation />
  }
  return (
    <>
      <BusinessImprovementPlanHeader />
      <section id="create-business-plan">
        <div className="d-flex flex-column bg-white my-2 cs-br-8">
          <div className="d-flex flex-column flex-lg-row align-items-lg-center border-bottom justify-content-between p-3">
            <div>
              <BigBoldText classNames={"d-block"}>Scalability Plan</BigBoldText>
              <SmallNormalText>
                Translate strategy into action and results with Scalability OKRs
                that keep your team focused on scaling every quarter.
              </SmallNormalText>
            </div>
            <div className="text-lg-end mt-3 mt-lg-0 mt-md-0">
              <SmallBoldText classNames={"d-block"}>
                {businessPlanGeneralData.quarter}
              </SmallBoldText>
            </div>
          </div>

          <div className="p-3 d-flex align-items-start">
            <div>
              <LightText>
                Scaling a business requires focus, team alignment and execution
                discipline.
                <br />
                Scalability Plan keeps your team extremely focused on a tiny number of
                critical strategic goals, or OKRs, you must achieve to scale. To learn
                more about OKRs,{" "}
                <Link to={COURSE_OVERVIEW.replace(":courseId", "78")} target="_blank">
                  <PrimaryNormalText
                    classNames={"text-decoration-underline cursor-pointer"}
                  >
                    take our Art of OKR Implementation course.
                  </PrimaryNormalText>
                </Link>
              </LightText>

              <PrimaryBoldText classNames={"d-block mt-3"}>
                Create your scalability plan with quarterly Scalability OKRs
              </PrimaryBoldText>
              {renderBIPSteps()}
              <StandardButton
                size="btn-lg"
                text={"View"}
                color="btn-rounded-success"
                onClick={() => {
                  history.push(
                    BUSINESS_IMPROVEMENT_PLAN_VIEW.replace(
                      ":planId",
                      businessPlanGeneralData.businessPlanId,
                    ).replace(":userId", params.userId),
                  );
                }}
                // isLoading={buttonDisabled}
                disabled={businessPlanGeneralData.latest_bip_state === "Empty" || businessPlanGeneralData.latest_bip_state === ""}
                icon={<ButtonIcon icon={ChevronRight} />}
                className="mt-4 d-flex align-items-center"
              />
              {renderInfoText()}
            </div>
            <img src="/assets/images/create-bip-image.svg" className="ms-4" />
          </div>
          {businessPlans.length > 0 &&
            <div className="p-3 border-top">
              <BoldText>History</BoldText>
              <div className="mt-3">
                <HabitBuilderTable columns={tableHeaders} data={businessPlans} />
              </div>
            </div>
          }

        </div>
      </section>
    </>
  );
}